function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import { createLeechViewer } from './LeechViewer';
import { MaterialManager } from "../wgs/render/MaterialManager";

// MultiViewerFactory - encapsulates the creation leech viewer.
export var MultiViewerFactory = /*#__PURE__*/function () {
  function MultiViewerFactory() {_classCallCheck(this, MultiViewerFactory);
    var glrenderer = Autodesk.Viewing.Private.createRenderer(undefined, { alpha: true });
    var materialManager = new MaterialManager(glrenderer);

    // Map of all the models that are already loaded some viewer.
    // Each item contains the model instance, and a counter of how many viewer's are using it.
    var loadedModels = {};

    this.sharedResources = {
      glrenderer: glrenderer,
      materialManager: materialManager,
      loadedModels: loadedModels };

  }_createClass(MultiViewerFactory, [{ key: "createViewer", value: function createViewer(

    container, config) {var ViewerClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Autodesk.Viewing.Viewer3D;
      return createLeechViewer(container, config, this.sharedResources, ViewerClass);
    } }]);return MultiViewerFactory;}();